/**
 * How a picked file reaches the run: uploaded once, then named by id.
 *
 * The Widget provides the uploader (bound to its token and app); the pickers
 * read it from context. Without one — a picker rendered on its own, in a test —
 * a file is read inline as before, which the run door still accepts.
 */

import { createContext } from 'preact'
import type { FileJSON } from './file-value'

export type FileUploader = (file: File) => Promise<FileJSON>

export const FileUploaderContext = createContext<FileUploader | null>(null)
